// attendanceAPI.js
export const sendAttendanceData = async (token, sections, activeSectionIndex, selectedDate, arr) => {
    try {
      const response = await fetch(`https://test.creative-its.com/back/api/student/attendance/${sections[activeSectionIndex].id}`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
          token: token,
          date: selectedDate,
          arr: arr
        })
      });
  
      console.log('Attendance data response:', response);
  
      return response;
    } catch (error) {
      throw error;
    }
  };
  